import { IWildWheelConfiguration } from '@GFTypes/GameStoreTypes/WildWheelConfiguration';

export const WILD_WHEEL_CONFIGURATION_DEFAULTS: IWildWheelConfiguration = {
    skippable: false,
    wheels: [
        {
            delay: 0,
            assignedReel: 0,
            multipliers: {},
            slotNameToRotate: '',
            spineName: '',
            skinName: 'default',
            flyFromSymbol: undefined,
            spinningDuration: 0
        }
    ],
    merge: {
        spineName: '',
        skinName: 'default',
        placeholderName: '',
        fontSize: 0,
        fontName: ''
    }
};
